
specialTags = 
	alliance: 'alliance'
	allied: 'alliance'
	empire: 'empire'
	imperial: 'empire'
	rocket: 'rocket'
	space: 'rocket'
	star: 'star'
	stars: 'star'
	beer: 'beer'

filters = 
	tagClass: -> (tag) ->
		if not tag then return 
		classes = ["tag-#{tag.slug}"]
		if tag.value
			parts = tag.value.split(/[-_]/)
			for part in parts
				if specialTags[part]
					classes.push "tag-special-#{specialTags[part]}"
		return classes

module.filter filters